<template>
  <div class="gradient-header diamond-bg-light relative overflow-hidden">
    <!-- Radial glow -->
    <div class="absolute -top-12 -right-12 w-48 h-48 rounded-full bg-mlb-red/10 blur-3xl pointer-events-none" />
    <div class="absolute -bottom-8 left-1/4 w-32 h-32 rounded-full bg-mlb-gold/8 blur-2xl pointer-events-none" />

    <div class="relative max-w-7xl mx-auto px-6 py-5">
      <div :class="centered ? 'text-center' : 'flex items-start justify-between gap-4'">
        <div class="min-w-0">
          <!-- Breadcrumb -->
          <div v-if="breadcrumb" class="flex items-center gap-1.5 mb-1.5">
            <span v-for="(crumb, i) in breadcrumbItems" :key="i" class="flex items-center gap-1.5">
              <span v-if="i > 0" class="text-blue-400/40 text-xs">/</span>
              <router-link
                v-if="crumb.to"
                :to="crumb.to"
                class="text-[11px] text-blue-300/60 hover:text-mlb-gold transition-colors font-medium"
                style="font-family: var(--font-display); letter-spacing: 0.04em"
              >{{ crumb.label }}</router-link>
              <span v-else class="text-[11px] text-blue-300/50 font-medium" style="font-family: var(--font-display); letter-spacing: 0.04em">{{ crumb.label }}</span>
            </span>
          </div>

          <!-- Title -->
          <h1
            class="text-2xl md:text-3xl font-black text-white tracking-wide leading-tight"
            style="font-family: var(--font-display); letter-spacing: 0.03em"
          >
            {{ title }}
          </h1>

          <!-- Subtitle -->
          <p v-if="subtitle" class="text-blue-200/70 text-sm mt-1 font-medium">{{ subtitle }}</p>
        </div>

        <!-- Slot actions (right side) -->
        <div v-if="!centered && $slots.default" class="hidden md:flex items-center gap-3 shrink-0 pt-0.5">
          <slot />
        </div>
      </div>

      <!-- Mobile slot -->
      <div v-if="!centered && $slots.default" class="md:hidden mt-3 flex flex-wrap gap-2">
        <slot />
      </div>
    </div>

    <!-- Gold bottom accent -->
    <div class="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-mlb-gold/40 to-transparent" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface BreadcrumbItem {
  label: string
  to?: string
}

const props = defineProps<{
  title: string
  subtitle?: string
  centered?: boolean
  breadcrumb?: BreadcrumbItem[]
}>()

const breadcrumbItems = computed(() => props.breadcrumb ?? [])
</script>
